import React from 'react'
import "../styles/RemoveButton.css"

const RemoveButton = ({handleRemoveLastActor, completeConnection}) => {
  return (
    <>
       {!completeConnection && (
            <button className="remove-button" onClick = {() => handleRemoveLastActor()}>
                  X
            </button>
          )
        }
    </>
  )
}

export default RemoveButton